
import { useEffect, useRef, useState } from 'react';

export default function FAQ() {
  const [isVisible, setIsVisible] = useState(false);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const faqs = [
    {
      question: 'Data Protection?',
      answer: 'AES-256 encryption in transit. Zero data retention. Processed in memory, never written to disk, deleted when your document is generated.',
    },
    {
      question: 'Hallucinations?',
      answer: 'Safeguards verify citations and legal language.',
    },
    {
      question: 'Courts?',
      answer: 'State and federal templates. Your local rules.',
    },
    {
      question: 'Letterhead?',
      answer: 'Not required, but you can upload yours.',
    },
    {
      question: 'Mobile app?',
      answer: 'Yes. Built mobile-first.',
    },
    {
      question: 'Refunds?',
      answer: '14 days, no questions.',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-20 sm:py-32 bg-[#09090b]">
      <div className="max-w-[900px] mx-auto px-5 sm:px-8">
        <h2
          className={`text-white text-[32px] sm:text-[44px] lg:text-[56px] font-bold text-center leading-tight mb-10 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          FAQ
        </h2>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-[#18181b] border border-[#27272a] rounded-xl overflow-hidden transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 sm:p-6 text-left hover:bg-[#1f1f23] transition-colors cursor-pointer"
              >
                <span className="text-white text-[15px] sm:text-[18px] font-semibold pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-[#06b6d4] text-[22px] sm:text-[24px] transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-48' : 'max-h-0'
                }`}
              >
                <p className="text-[#a1a1aa] text-[14px] sm:text-[16px] px-4 sm:px-6 pb-4 sm:pb-6 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
